import { Inject, Injectable, InjectionToken } from '@angular/core';
import { CacheService } from '@se/se.ui.html5';
import { PatientSettings } from 'estensa-module';
import { Observable, from, of } from 'rxjs';


export const ESTENSA_MODULE_PATIENT_SETTINGS_SERVICE = new InjectionToken('estensa.module.patient.settings.service');

export interface IPatientSettingsServiceNg1 {
    getAsJSON(): Promise<Partial<PatientSettings>>;
    patientSettings?: Partial<PatientSettings>;
}

export class NullPatientSettingsService {
    getAsJSON() {
        return of({});
    }
}

@Injectable({
    providedIn: 'root',
})
export class PatientSettingsService {
    constructor(
        @Inject(ESTENSA_MODULE_PATIENT_SETTINGS_SERVICE) private settingsService: IPatientSettingsServiceNg1,
        private cacheService: CacheService,
    ) {}

    getSettings(): Observable<any> {
        return this.cacheService.get('PatientSettings', from(this.settingsService.getAsJSON()));
    }

    enableAllBusinessUnitExaminationSearch() {
        return this.settingsService.patientSettings?.enableAllBusinessUnitExaminationSearch;
    }
}
